import React from 'react';
import { Table } from 'antd';

export const CustomTable = ({
    className = '',
    variant,
    pagination,
    ...rest
}) => {
    const baseClassName =
        "[&_.ant-table-header]:!mb-0 [&_.ant-table-thead>tr>th]:!border-b-0 [&_.ant-table-thead>tr>th]:!py-3 [&_.ant-table-tbody>tr>td]:!py-3 [&_.ant-table-body]:!border-t-0 [&_.ant-table-body]:!shadow-none [&_.ant-table-container::before]:!hidden [&_.ant-table-container::after]:!hidden [&_.ant-table_table]:!border-collapse [&_.ant-table_table]:[border-spacing:0] [&_.ant-table-pagination.ant-pagination]:!my-2";

    const variantClassName =
        variant === 'split'
            ? '[&_.ant-table-header]:!pb-0 [&_.ant-table-body]:!mt-0'
            : '';

    const mergedClassName = [baseClassName, variantClassName, className]
        .filter(Boolean)
        .join(' ');

    let mergedPagination = pagination;
    if (pagination && typeof pagination === 'object') {
        mergedPagination = {
            showSizeChanger: false,
            ...pagination,
        };
    }

    return (
        <Table
            className={mergedClassName}
            pagination={mergedPagination}
            {...rest}
        />
    );
};
